const statsPreview = [
    {
        id: 1,
        img:
            'https://img.icons8.com/external-vitaliy-gorbachev-lineal-vitaly-gorbachev/60/ffffff/external-pizza-fast-food-vitaliy-gorbachev-lineal-vitaly-gorbachev.png',
        stats: '50',
        name: 'Pizza Branches',
    },
    {
        id: 2,
        img:
            'https://img.icons8.com/external-kiranshastry-lineal-kiranshastry/64/ffffff/external-award-business-kiranshastry-lineal-kiranshastry.png',
        stats: '200',
        name: 'Number of Awards',
    },
    {
        id: 3,
        img:
            'https://img.icons8.com/external-kiranshastry-lineal-kiranshastry/64/ffffff/external-user-advertising-kiranshastry-lineal-kiranshastry-2.png',
        stats: '10.485',
        name: 'Happy Customers',
    },
    {
        id: 4,
        img:
            'https://img.icons8.com/external-kiranshastry-lineal-kiranshastry/64/ffffff/external-chef-interface-kiranshastry-lineal-kiranshastry.png',
        stats: '400',
        name: 'Staff',
    },
]

export default statsPreview;